import React, { useCallback, useEffect, useRef } from 'react'
import useIntroStore from 'hooks/useIntroStore'
import Modal from '@ui/components/Modal'
import AnimatedModalPanel from '@ui/animated/AnimatedModalPanel'
import { useQrScanner } from '@/common/CodeScanner/useQrScanner'
import useStaffQrHandler from 'hooks/staff/useStaffQrHandler'
import { StaffLoginModal } from './StaffLoginModal'
import { router } from 'expo-router'

export const StandaloneStaffLoginModal = () => {
  const mode = useIntroStore((s) => s.mode)
  const goBack = useIntroStore((s) => s.goBack)
  const toggleMode = useIntroStore((s) => s.toggleMode)
  const prevScreen = useIntroStore((s) => s.prevScreen)
  const setPrevScreen = useIntroStore((s) => s.setPrevScreen)
  const qrMode = useQrScanner((s) => s.mode)
  const setQrMode = useQrScanner((s) => s.setMode)

  const refPrevQrMode = useRef(qrMode)

  const enabled = mode === 'staff'

  useEffect(() => {
    if (enabled) {
      refPrevQrMode.current = qrMode
      setQrMode('staff')
      return
    }
    if (refPrevQrMode.current !== qrMode) {
      setQrMode(refPrevQrMode.current)
    }
  }, [enabled])

  const onClose = () => {
    toggleMode('none')

    if (goBack && !prevScreen) {
      router.back()
    }
    if (prevScreen) {
      router.navigate(prevScreen)
    }
    // Always reset the prev screen to prevent loops
    setPrevScreen(undefined)
  }

  useStaffQrHandler()

  return (
    // <ModalBottom close={onClose} open={enabled}>
    <Modal enabled={enabled} onClose={onClose}>
      <AnimatedModalPanel>
        <StaffLoginModal onClose={onClose} />
      </AnimatedModalPanel>
    </Modal>
    // </ModalBottom>
  )
}
